module.exports = __webpack_public_path__ + "static/media/Phones.34f2ca2a.svg";